// Libs / Helpers
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import filesaver from 'file-saver';
import DocumentCard from 'Components/cards/DocumentCard';
import SingleDateInput from 'Components/forms/SingleDateInput/SingleDateInput';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import {
  getReportData,
  documentViewDownloadAction,
  getInventoryReportData,
  inventoryViewDownloadAction,
} from 'Apis/reportApi.js';

import './SettlementReports.scss';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setSearchOpenFlag } from 'Actions/drawerAction';

export class SettlementReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportData: {},
      currentValues: '',
      isLoading: true,
    };
    this.attachBindings();
  }

  attachBindings() {
    this.getReportData = this.getReportData.bind(this);
    this.download = this.download.bind(this);
    this.handleSingleDateChange = this.handleSingleDateChange.bind(this);
    this.getDocumentCard = this.getDocumentCard.bind(this);
  }

  componentDidMount() {
    localStorage.setItem('isProductReportView',false);
    this.getReportData();
  }

  getReportData(selectedDate, acquirerAccessList) {
    this.setState({
      isLoading: true,
    });
    let acquirerCode= getAcquirerAccessList();
    if((acquirerCode.includes('MXP') || acquirerCode.includes('MXI')) && !acquirerCode.includes('GPN')) {
      acquirerCode.push('GPN');
    }
    if(this.props.reportName === 'Settlement Reports'){
      return getReportData(selectedDate, acquirerCode)
      .then((apiResponse) => {
        const reportData = apiResponse.data;
        this.setState({
          reportData: reportData,
          isLoading: false,
        });
      })
      .catch((error) => {
         this.setState({ reportData: [], isLoading: false });
        console.log('Error Occured while fetching report data', error);
      });
    } else {
      let acqCode=this.props.location?.state?.acquirerCode;
      let reportId=this.props.location?.state?.reportId;
      return getInventoryReportData(selectedDate,acqCode,reportId)
      .then((apiResponse) => {
        const reportData = apiResponse.data;
        this.setState({
          reportData: reportData,
          isLoading: false,
        });
      })
      .catch((error) => {
         this.setState({ reportData: [], isLoading: false });
        console.log('Error Occured while fetching report data', error);
      });
    }

  }

  download(document) {
   if(this.props.reportName === 'Settlement Reports'){
    documentViewDownloadAction('csv', document)
      .then((response) => {
        filesaver.saveAs(response, document.fileName);
      })
      .catch((error) => {
        console.log('Error Occured while Downloading', error);
      });
  } else {
    inventoryViewDownloadAction('csv', document)
      .then((response) => {
        filesaver.saveAs(response, document.fileName);
      })
      .catch((error) => {
        console.log('Error Occured while Downloading', error);
      });
  }
}

  handleSingleDateChange = (id, value) => {
    let acquirerCode= getAcquirerAccessList();
    if((acquirerCode.includes('MXP') || acquirerCode.includes('MXI')) && !acquirerCode.includes('GPN')) {
      acquirerCode.push('GPN');
    }
    let newValues = this.state.currentValues;
    let valueFound = false;
    if (newValues != '') {
      newValues = moment(value).format('MM/DD/YYYY');
      valueFound = true;
    }
    if (valueFound === false) {
      newValues = moment(value).format('MM/DD/YYYY')
    }
    this.getReportData(newValues, acquirerCode);
    this.setState({
      currentValues: newValues,
    });
  }

  getDocumentCard(reportName, reports) {
    
    return (
      <div className="card-list">
        <h2 className="card-category">
          <b>
            {reportName}
          </b>
        </h2>{
          reports.map((document,index) => {
            return (
              <DocumentCard
                key={index}
                title={document.fileName}
                primaryAction={() => {
                  this.download(document);
                }}
                primaryActionText="Download"
                secondaryOptions={[]}
                document={document}
              >
                <span>
                  <span className="document-generated">
                   Generated
                   </span>
                    &nbsp;
                  <span className="document-creation-date">
                    {document.generetedDate}
                  </span>
                  &nbsp;
                  &nbsp; 
                  <span className="document-generated">
                  Size 
                  </span>
                  &nbsp;
                  <span className="document-creation-date">
                    {document.size != null ? `${document.size} KB` : "--"}
                  </span>
                </span>
              </DocumentCard>
            );
          })
        }
      </div>
    );
  }

  get reportCards() {
    const parseSettlementCategories =  (
      <div>
        <span className="left-documents">
          {
            this.getDocumentCard("GL INCOMING ", 
            this.state.reportData.glIncomingDetails != undefined ?
            this.state.reportData.glIncomingDetails : [])
          }
          {
            this.getDocumentCard("8090 OUTGOING ",
            this.state.reportData.gl8090OutgoingDetails != undefined ? 
            this.state.reportData.gl8090OutgoingDetails :[])
          }
        </span>
        <span className="right-documents">
          {
            this.getDocumentCard("GL OUTGOING ",
            this.state.reportData.glOutgoingDetails != undefined ? 
            this.state.reportData.glOutgoingDetails :[])
          }
          {
            this.getDocumentCard("DOIR", 
            this.state.reportData.doirDetails != undefined ? 
            this.state.reportData.doirDetails: [])
          }
        </span>
      </div>
    )

    const parseInventoryCategories =  (
      <div>
        <span className="inventory-documents">
          {
            this.getDocumentCard(this.props.reportName, 
            this.state.reportData.inventoryReportDetails != undefined ?
            this.state.reportData.inventoryReportDetails : [])
          }
        </span>
      </div>
    )

    return (
      <section className="reports-container">
        <div className={this.props.isSearchActive ? 'main-content--header secondary-header' : "main-content--header "} style={{zIndex :2}}>
          <h1> {this.props.reportName} </h1>
        </div>
        <span className="SingleCalender" style={{marginTop: this.props.isSearchActive ? "20px" : "84px"}}>
          <div className="calenderBox">
            <SingleDateInput
              id='reportDate'
              name='Report Date'
              onApply={this.handleSingleDateChange}
              title='REPORT DATE'
              singleDate={this.state.currentValues}
              minDate={this.props.reportName === 'Settlement Reports' ? moment().subtract(30, 'days') : moment().subtract(3, 'months')}
              maxDate={moment()}
              dateFormat='MM/DD/YYYY'
            />
          </div>
        </span>
        {this.props.reportName === 'Settlement Reports' ? parseSettlementCategories : parseInventoryCategories}
      </section >
    );
  }

  render() {
    window.document.title = this.props.reportName;
    return (
      <section className="reports-container">
        {
          (!this.state.isLoading) ? (
          this.reportCards  ) :
          (
              this.state.isLoading && (
                <div className="ball-sync-loader loader" style={{ height: 200, backgroundColor: 'white' }}>
                  <BVLoader20 />
                </div>
              )      
          )
        }
      </section>
    );
  }
}

SettlementReports.propTypes = {
 
};

SettlementReports.defaultProps = {

};

const mapStateToProps = (state) => ({
  isSearchActive: state.appSearch.isSearchActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
      setSearchOpenFlag: (isSearchActive) => {
          dispatch(setSearchOpenFlag(isSearchActive));
      },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SettlementReports));
